'use client';

import { useEffect } from 'react';
import { reportRenderNotFound } from '@/lib/renderBeacon';

export function NotFoundBeacon() {
  useEffect(() => {
    reportRenderNotFound();
  }, []);

  return null;
}
